import React, { useState, useEffect } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { useCurrency } from "../../../../context/currencyContext";
import axios from 'axios';
import "./setting.css";

const API_URL = process.env.REACT_APP_API_URL || 'https://hms.backend.hiragroupcloud.com';

const PreferencesTab = () => {
  const { currency, updateCurrencyPreference, formatAmount, refreshCurrency } = useCurrency();

  const [caseId, setCaseId] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [outsourceInvoiceNumber, setOutsourceInvoiceNumber] = useState("");
  const [userLabId, setUserLabId] = useState("");
  const [nextCaseId, setNextCaseId] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [saveError, setSaveError] = useState("");

  const [formData, setFormData] = useState({
    labID: "",
    labName: "",
    address: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    telephone: "",
    fax: "",
    email: "",
    website: "",
    timeZone: "",
    licenseNumber: "",
    shippingAddress: "",
    shippingAddressLine2: "",
    Name: "",
    shippingState: "",
    shippingCity: "",
    shippingZipCode: "",
    supportName: "",
    supportLink: "",
    supportContent: "",
    prospect: "",
    showShippingAddress: false,
  });

  const [selectedCurrency, setSelectedCurrency] = useState(currency.currencyCode);
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateMessage, setUpdateMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [isToggled, setIsToggled] = useState(false);
  const [isToggle, setIsToggle] = useState(false);

  const handleToggled = () => {
    setIsToggle((prevState) => !prevState);
  };

  const [isAutoRescheduleToggled, setIsAutoRescheduleToggled] = useState(false);
  const [isTaskCompletionToggled, setIsTaskCompletionToggled] = useState(false);
  const [isCaseTaskChartToggled, setIsCaseTaskChartToggled] = useState(false);

  const handleAutoRescheduleToggle = () => {
    setIsAutoRescheduleToggled(!isAutoRescheduleToggled);
  };

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const handleTaskCompletionToggle = () => {
    setIsTaskCompletionToggled(!isTaskCompletionToggled);
  };

  const handleCaseTaskChartToggle = () => {
    setIsCaseTaskChartToggled(!isCaseTaskChartToggled);
  };

  const [isChargeInterestToggled, setIsChargeInterestToggled] = useState(false);
  const [chargeInterestValue, setChargeInterestValue] = useState(0);

  const handleChargeInterestToggle = () => {
    setIsChargeInterestToggled(!isChargeInterestToggled);
  };

  const handleChargeInterestChange = (event) => {
    setChargeInterestValue(event.target.value);
  };

  const handleCaseIdChange = (e) => {
    const newCaseId = e.target.value;
    setCaseId(newCaseId);
    const calculatedNextId = calculateNextCaseId(newCaseId);
    setNextCaseId(calculatedNextId);
  };

  const handleInvoiceNumberChange = (e) => {
    const newInvoiceNumber = e.target.value;
    setInvoiceNumber(newInvoiceNumber);
  };

  const handleOutsourceInvoiceNumberChange = (e) => {
    const newOutsourceInvoiceNumber = e.target.value;
    setOutsourceInvoiceNumber(newOutsourceInvoiceNumber);
  };

  const toggleSwitch = (isToggled, handleToggle, marginLeft) => (
    <div
      onClick={handleToggle}
      style={{
        width: "50px",
        height: "25px",
        backgroundColor: isToggled ? "#004aad" : "#ccc",
        borderRadius: "25px",
        position: "relative",
        cursor: "pointer",
        transition: "background-color 0.3s",
        marginLeft: marginLeft,
      }}
    >
      <div
        style={{
          width: "22px",
          height: "22px",
          backgroundColor: "#fff",
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          left: isToggled ? "26px" : "2px",
          transform: "translateY(-50%)",
          transition: "left 0.3s",
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
        }}
      />
    </div>
  );

  const handleCurrencyChange = async () => {
    if (selectedCurrency === currency.currencyCode) {
      setUpdateMessage("Currency is already set to " + selectedCurrency);
      setTimeout(() => setUpdateMessage(""), 3000);
      return;
    }

    setIsUpdating(true);
    setUpdateMessage("");

    const result = await updateCurrencyPreference(selectedCurrency);

    if (result.success) {
      setUpdateMessage(`Currency successfully updated to ${selectedCurrency}`);
      if (refreshCurrency) {
        await refreshCurrency();
      }
    } else {
      setUpdateMessage(result.error || "Failed to update currency");
    }

    setIsUpdating(false);

    setTimeout(() => {
      setUpdateMessage("");
    }, 3000);
  };

  const calculateNextCaseId = (currentCaseId) => {
    if (!currentCaseId || currentCaseId.trim() === "") {
      return "";
    }

    const currentNumber = parseInt(currentCaseId, 10);
    if (isNaN(currentNumber)) {
      return "";
    }

    const nextNumber = currentNumber + 1;
    const currentLength = currentCaseId.length;
    return String(nextNumber).padStart(currentLength, '0');
  };

  const fetchUserPreferences = async () => {
    try {
      let storedUserLabId = localStorage.getItem('userLabId');

      if (!storedUserLabId) {
        storedUserLabId = '00000001';
        localStorage.setItem('userLabId', storedUserLabId);
      }

      setUserLabId(storedUserLabId);

      // ✅ Get token for authorization
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token') || '';

      const response = await axios.get(`${API_URL}/api/preferences/${storedUserLabId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'userLabId': storedUserLabId,
          'x-user-lab-id': storedUserLabId
        }
      });

      if (response.data.success && response.data.data) {
        const fetchedCaseId = response.data.data.caseId || "";
        const fetchedInvoiceNumber = response.data.data.invoiceNumber || "";
        const fetchedOutsourceInvoiceNumber = response.data.data.outsourceInvoiceNumber || "";

        setCaseId(fetchedCaseId);
        setInvoiceNumber(fetchedInvoiceNumber);
        setOutsourceInvoiceNumber(fetchedOutsourceInvoiceNumber);

        const calculatedNextId = calculateNextCaseId(fetchedCaseId);
        setNextCaseId(calculatedNextId);
      }
    } catch (error) {
      // Don't show error to user, just use defaults
    }
  };

  const savePreferences = async () => {
    const currentLabId = userLabId || localStorage.getItem('userLabId');

    if (!currentLabId) {
      setSaveError("User Lab ID not found. Please refresh the page.");
      setTimeout(() => setSaveError(""), 3000);
      return;
    }

    if (!caseId && !invoiceNumber && !outsourceInvoiceNumber) {
      setSaveError("Please enter at least one value before saving");
      setTimeout(() => setSaveError(""), 3000);
      return;
    }

    setIsLoading(true);
    setSaveMessage("");
    setSaveError("");

    try {
      const requestData = {
        userLabId: currentLabId,
        caseId: caseId || '',
        invoiceNumber: invoiceNumber || '',
        outsourceInvoiceNumber: outsourceInvoiceNumber || ''
      };

      // ✅ Get token for authorization
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token') || '';

      const response = await axios.post(`${API_URL}/api/preferences/`, requestData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'userLabId': currentLabId,
          'x-user-lab-id': currentLabId
        }
      });
      if (response.data.success) {
        setSaveMessage(`Preferences saved successfully! Case ID: ${caseId || 'Not set'}, Invoice: ${invoiceNumber || 'Not set'}, Outsource Invoice: ${outsourceInvoiceNumber || 'Not set'}`);
        setTimeout(() => setSaveMessage(""), 3000);

        await fetchUserPreferences();
      } else {
        throw new Error(response.data.message || 'Failed to save preferences');
      }
    } catch (error) {
      setSaveError(error.response?.data?.message || "Failed to save preferences");
      setTimeout(() => setSaveError(""), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setSelectedCurrency(currency.currencyCode);
    fetchUserPreferences();
  }, []);

  useEffect(() => {
    setSelectedCurrency(currency.currencyCode);
  }, [currency.currencyCode]);

  return (
    <div style={{ padding: "5px", backgroundColor: "#ffffff", width: "100%" }}>

      {/* Document Numbers Section */}
      <h4 className="pref-section-title">Document Numbers</h4>
      <div className="pref-box">
        <div className="pref-row" style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <label htmlFor="caseId" className="pref-label" style={{ marginBottom: "8px" }}>
            Current/Starting Case ID
          </label>
          <input
            type="text"
            id="caseId"
            value={caseId}
            onChange={handleCaseIdChange}
            placeholder="Enter starting Case ID (e.g., 40001)"
            className="pref-control"
            style={{ maxWidth: "100%" }}
          />
          <small className="pref-note">
            This is the starting case ID. Next case ID will be automatically calculated.
          </small>
        </div>

        <div className="pref-row" style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <label htmlFor="invoiceNumber" className="pref-label" style={{ marginBottom: "8px" }}>
            Next Invoice Number
          </label>
          <input
            type="text"
            id="invoiceNumber"
            value={invoiceNumber}
            onChange={handleInvoiceNumberChange}
            placeholder="Enter starting Invoice Number (e.g., 00000001)"
            className="pref-control"
            style={{ maxWidth: "100%" }}
          />
          <small className="pref-note">
            Next invoice created will use this number if available
          </small>
        </div>

        <div className="pref-row" style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <label htmlFor="outsourceInvoiceNumber" className="pref-label" style={{ marginBottom: "8px" }}>
            Next Outsource Invoice Number
          </label>
          <input
            type="text"
            id="outsourceInvoiceNumber"
            value={outsourceInvoiceNumber}
            onChange={handleOutsourceInvoiceNumberChange}
            placeholder="Enter starting Outsource Invoice Number (e.g., 00000001)"
            className="pref-control"
            style={{ maxWidth: "100%" }}
          />
          <small className="pref-note">
            Next outsource invoice created will use this number if available
          </small>
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label className="pref-labid-label">
            User Lab ID (Auto-detected)
          </label>
          <div className="pref-labid-box">
            {userLabId || "Loading..."}
          </div>
        </div>
      </div>

      {/* Account Preferences */}
      <h4 className="pref-section-title">Account Preferences</h4>
      <div className="pref-box">
        <div className="pref-row">
          <label htmlFor="autoAccept" className="pref-label">
            Auto Accept
          </label>
          {toggleSwitch(isToggled, handleToggle, "0")}
        </div>

        <div className="pref-row">
          <label htmlFor="externalSetup" className="pref-label">
            Check External Setup
          </label>
          {toggleSwitch(isToggle, handleToggled, "0")}
        </div>

        <div className="pref-row">
          <label htmlFor="prospect" className="pref-label">
            Change to Prospect after
          </label>
          <input
            type="text"
            id="prospect"
            name="prospect"
            value={formData.prospect}
            onChange={handleChange}
            className="pref-control pref-control-sm"
          />
          <p className="pref-hint">Months of inactivity</p>
        </div>
      </div>

      <br />

      {/* Case Preferences */}
      <div style={{ marginBottom: "10px" }}>
        <h3 className="pref-section-title">Case Preferences</h3>
        <div className="pref-box">
          <div className="pref-row">
            <label htmlFor="Name" className="pref-label">
              Rx Procedure Sort
            </label>
            <select
              id="Name"
              name="Name"
              value={formData.Name}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            >
              <option value="Name">Name</option>
              <option value="Maryam">Maryam</option>
              <option value="Ayesha">Ayesha</option>
            </select>
          </div>

          <div className="pref-row">
            <label htmlFor="shippingState" className="pref-label">
              Enable Coupons
            </label>
          </div>

          <div className="pref-row">
            <label htmlFor="Name" className="pref-label">
              Rx Procedure Sort
            </label>
            <select
              id="Name"
              name="Name"
              value={formData.Name}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            >
              <option value="Name">Name</option>
              <option value="Maryam">Maryam</option>
              <option value="Ayesha">Ayesha</option>
            </select>
          </div>

          <div className="pref-row">
            <label htmlFor="Name" className="pref-label">
              Alloy Mass
            </label>
            <select
              id="Name"
              name="Name"
              value={formData.Name}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            >
              <option value="Name">Name</option>
              <option value="Maryam">Maryam</option>
              <option value="Ayesha">Ayesha</option>
            </select>
          </div>

          <div className="pref-row">
            <label htmlFor="prospect" className="pref-label">
              Default Alloy Mass per Unit
            </label>
            <input
              type="text"
              id="prospect"
              name="prospect"
              value={formData.prospect}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            />
          </div>

          <div className="pref-row">
            <label htmlFor="Name" className="pref-label">
              Work Ticket Sticker Size
            </label>
            <select
              id="Name"
              name="Name"
              value={formData.Name}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            >
              <option value="Name">Name</option>
              <option value="Maryam">Maryam</option>
              <option value="Ayesha">Ayesha</option>
            </select>
          </div>

          <div className="pref-row">
            <label htmlFor="Name" className="pref-label">
              Default Shipper
            </label>
            <select
              id="Name"
              name="Name"
              value={formData.Name}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            >
              <option value="Name">Name</option>
              <option value="Maryam">Maryam</option>
              <option value="Ayesha">Ayesha</option>
            </select>
          </div>

          <div className="pref-row">
            <label htmlFor="prospect" className="pref-label">
              JDE Number
            </label>
            <input
              type="text"
              id="prospect"
              name="prospect"
              value={formData.prospect}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            />
          </div>

          <div className="pref-row">
            <label htmlFor="prospect" className="pref-label">
              Case Prefix
            </label>
            <input
              type="text"
              id="prospect"
              name="prospect"
              value={formData.prospect}
              onChange={handleChange}
              className="pref-control pref-control-sm"
            />
          </div>

          <div className="pref-row">
            <label htmlFor="nextCaseId" className="pref-label">
              Next Case ID
            </label>
            <input
              type="text"
              id="nextCaseId"
              name="nextCaseId"
              value={nextCaseId}
              placeholder="Next case ID will appear here"
              className="pref-control pref-control-sm pref-input-readonly"
              readOnly
            />
            <small className="pref-hint">
              Auto-calculated from current case ID + 1
            </small>
          </div>

          <div className="pref-toggle-row">
            <label htmlFor="autoReschedule" className="pref-label">
              Auto Reschedule Tasks
            </label>
            {toggleSwitch(isAutoRescheduleToggled, handleAutoRescheduleToggle, "0")}
            <p className="pref-hint">
              Case task chart, on task completion reschedule remaining tasks
            </p>
          </div>

          <div className="pref-toggle-row">
            <label htmlFor="taskCompletion" className="pref-label">
              Task Completion
            </label>
            {toggleSwitch(isTaskCompletionToggled, handleTaskCompletionToggle, "0")}
            <p className="pref-hint">
              Task completion window, allow Out-of-order scanning for all tasks
            </p>
          </div>

          <div className="pref-toggle-row">
            <label className="pref-label" style={{ visibility: "hidden" }}>.</label>
            {toggleSwitch(isCaseTaskChartToggled, handleCaseTaskChartToggle, "0")}
            <p className="pref-hint">
              Case task chart, allow out of order checking for all tasks
            </p>
          </div>
        </div>
      </div>

      {/* Finances */}
      <h2 className="pref-section-title">Finances</h2>
      <div className="pref-box">
        <div className="pref-currency-row">
          <label htmlFor="currency" className="pref-label">
            Currency
          </label>
          <select
            id="currency"
            value={selectedCurrency}
            onChange={(e) => setSelectedCurrency(e.target.value)}
            className="pref-control pref-control-sm"
          >
            <option value="GBP">GBP (£)</option>
            <option value="PKR">PKR (Rs)</option>
            <option value="USD">USD ($)</option>
            <option value="EUR">EUR (€)</option>
            <option value="INR">INR (₹)</option>
          </select>
          <button
            onClick={handleCurrencyChange}
            disabled={isUpdating}
            className="pref-confirm-btn"
          >
            {isUpdating ? "Updating..." : "Confirm"}
          </button>
        </div>

        {updateMessage && (
          <div
            style={{
              marginBottom: "12px",
              padding: "10px",
              backgroundColor: updateMessage.includes("successfully") ? "#d4edda" : "#f8d7da",
              color: updateMessage.includes("successfully") ? "#155724" : "#721c24",
              border: "1px solid",
              borderColor: updateMessage.includes("successfully") ? "#c3e6cb" : "#f5c6cb",
              borderRadius: "4px",
            }}
          >
            {updateMessage}
          </div>
        )}

        <div className="pref-row">
          <label htmlFor="balanceAging" className="pref-label">
            Balance Aging
          </label>
          <input
            type="text"
            id="balanceAging"
            value="Statement Based"
            readOnly
            className="pref-control pref-control-sm"
          />
        </div>

        <div className="pref-row">
          <label htmlFor="chargeInterestToggle" className="pref-label">
            Charge Interest
          </label>
          {toggleSwitch(isChargeInterestToggled, handleChargeInterestToggle, "0")}
        </div>

        <div className="pref-row">
          <label htmlFor="interestInput" className="pref-label">
            Charge Interest Value
          </label>
          <input
            type="number"
            id="interestInput"
            value={chargeInterestValue}
            onChange={handleChargeInterestChange}
            className="pref-control pref-control-sm"
          />
        </div>

        <div className="pref-row">
          <label htmlFor="ddxPrepayments" className="pref-label">
            DDX Prepayments
          </label>
          <select id="ddxPrepayments" className="pref-control pref-control-sm">
            <option value="Option1">Option 1</option>
            <option value="Option2">Option 2</option>
            <option value="Option3">Option 3</option>
          </select>
        </div>
      </div>

      {/* Invoices and Statements */}
      <h4 className="pref-section-title">Invoices and Statements</h4>
      <div className="pref-box">
        <div className="pref-row">
          <label htmlFor="supportLink" className="pref-label">
            Support Link
          </label>
          <input
            type="text"
            id="supportLink"
            name="supportLink"
            value={formData.supportLink}
            onChange={handleChange}
            className="pref-control"
          />
        </div>

        <div className="pref-row">
          <label htmlFor="supportName" className="pref-label">
            Support Name
          </label>
          <input
            type="text"
            id="supportName"
            name="supportName"
            value={formData.supportName}
            onChange={handleChange}
            className="pref-control"
          />
        </div>

        <div className="pref-row">
          <label htmlFor="supportContent" className="pref-label">
            Support Content
          </label>
          <input
            type="text"
            id="supportContent"
            name="supportContent"
            value={formData.supportContent}
            onChange={handleChange}
            className="pref-control"
          />
        </div>
      </div>

      {/* User Session Management */}
      <div>
        <h3 className="pref-section-title">User Session Management</h3>
        <div className="pref-box">
          <div className="pref-session-row">
            <label htmlFor="sessionSecurity" className="pref-label">
              Session Security Profile
            </label>
            <select id="sessionSecurity" className="pref-control pref-control-sm">
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
            </select>
          </div>

          <div className="pref-session-row">
            <label htmlFor="closeSession" className="pref-label">
              Close Session on Browser Close
            </label>
            <label className="switch" style={{ marginLeft: "0" }}>
              <input
                type="checkbox"
                checked={isChargeInterestToggled}
                onChange={handleChargeInterestToggle}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <style>
          {`
            .switch {
              position: relative;
              display: inline-block;
              width: 50px;
              height: 28px;
            }
            .switch input {
              opacity: 0;
              width: 0;
              height: 0;
            }
            .slider {
              position: absolute;
              cursor: pointer;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #ccc;
              transition: 0.4s;
              border-radius: 34px;
            }
            .slider:before {
              position: absolute;
              content: "";
              height: 22px;
              width: 22px;
              left: 3px;
              bottom: 3px;
              background-color: white;
              transition: 0.4s;
              border-radius: 50%;
            }
            input:checked + .slider {
              background-color: #004aad;
            }
            input:checked + .slider:before {
              transform: translateX(22px);
            }
          `}
        </style>
      </div>

      {/* Save Messages */}
      {saveMessage && (
        <div className="pref-msg-success">{saveMessage}</div>
      )}

      {saveError && (
        <div className="pref-msg-error">{saveError}</div>
      )}

      <div style={{ marginTop: "20px" }}>
        <button
          onClick={savePreferences}
          disabled={isLoading}
          className="pref-save-btn"
        >
          <FaPencilAlt /> {isLoading ? "Saving..." : "Save Preferences"}
        </button>
      </div>
    </div>
  );
};

export default PreferencesTab;